import {Component, Input, OnInit} from '@angular/core';
import {DocumentTypeModel} from '../../shared/dto/document-type.model';
import {DocumentViewerComponent} from '../../approval-process/approval-process-request-viewer/document-viewer/document-viewer.component';
import {MatTableDataSource} from '@angular/material/table';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ApplicantRequestService} from '../../service/applicant-request.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {DocumentDetailsService} from '../../service/document-details.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-verify-doc-view',
  templateUrl: './verify-doc-view.component.html',
  styleUrls: ['./verify-doc-view.component.scss']
})
export class VerifyDocViewComponent implements OnInit {


  @Input() applicationId: number;
  public documentTypeModel: DocumentTypeModel[] = [];
  displayedColumns: string[] = ['description','action'];
  dataSource: MatTableDataSource<any>;
  public pages: any = [];
  public loader: boolean = false;
  public safeUrl: SafeResourceUrl;
  docType: DocumentTypeModel = new DocumentTypeModel();
  isLoading: boolean = false;
  documentDetails: any = [];

  constructor(private applicantRequestService: ApplicantRequestService, private documentDetailsService: DocumentDetailsService,
              private sanitizer: DomSanitizer, private modalService: NgbModal,) { }

  ngOnInit() {
    this.getDocumentType();
  }

  getDocumentType() {
    this.isLoading = true;
    this.applicantRequestService.getDocumentType(this.applicationId).subscribe(
      (result: any ) => {
        this.isLoading = false;
        this.documentTypeModel = result;
        this.documentDetails = this.documentTypeModel;
        this.dataSource = new MatTableDataSource(this.documentTypeModel);
      }
    );
  }

  transform(base64Image) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(base64Image);
  }

  viewDoc(documentTypeCode:string) {
    this.docType.appRefID = this.applicationId;
    this.docType.documentTypeCode = documentTypeCode;

    const modalRef = this.modalService.open(DocumentViewerComponent,{size: 'lg'});
    let data = {
      doc: this.docType,
    }

    modalRef.componentInstance.fromParent = data;
  }

  deleteDoc(docID: number, appRefID: number, type: string) {

    swal.fire({
      title: "Are you sure, you want to delete?",
      text: "",
      showCancelButton: true,

      confirmButtonText: "Yes"
    }).then((result)=> {
        if(result.value) {
          const docType = new DocumentTypeModel();
          docType.appRefID = this.applicationId;
          docType.docID = docID;
          docType.documentTypeCode = type;
          this.applicantRequestService.deleteDocumentType(docType).subscribe(
            (res: any) => {
              this.getDocumentType();
            }
          );
        }
      }, reason => {
      }
    );


  }

}
